module.exports = __webpack_public_path__ + "static/pic04-e2db96cd5eec25ebe26cb0525e9589d6.jpg";